<page-toolbar [title]="title"></page-toolbar>

<page-content *ngIf="!!customer">

  <mat-card appearance="outlined">
    <mat-card-title>Infos: {{customer.company}}</mat-card-title>
    <mat-list>
      <mat-list-item>
        <span class="label">Screen UUID: </span><span>{{customer.screenUuid}}</span>
      </mat-list-item>
    </mat-list>
  </mat-card>

  <div class="spacer"></div>
  <mat-card appearance="outlined" *ngIf="!!assignedImports">
    <mat-card-title class="json-list-title">Imports</mat-card-title>
    <data-table
      (detail)="onDetail($event)"
      [columns]="dataTableColumns"
      [dataProviderParams]="{}"
      [hideSearch]="true"
      [plainData]="assignedImports"></data-table>
  </mat-card>

</page-content>
